module.exports = __webpack_public_path__ + "img/advantage3_1@2x.d7402db6.png";